module.exports = __webpack_public_path__ + "static/img/son3.14aaa69c.png";